"use client";

import Slide from "@/components/_types/slide";
import ColorfulCard from "@/components/colorful/colorful-card/colorful-card";
import { getType } from "@/components/util/functions";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const ColorfulSlider = ({
	id,
	setActiveColor,
	slides,
	centeredSlides,
	kind,
	activeGenre,
}: {
	id: string;
	setActiveColor?: any;
	slides: Slide[];
	centeredSlides: boolean;
	kind?: string;
	activeGenre?: string;
}) => {
	setActiveColor &&
		setActiveColor(
			slides[0]?.cutinScore == null || slides[0]?.cutinScore < 4
				? "#2CC2F9"
				: slides[0]?.cutinScore <= 7
				? "#A9F958"
				: "#FE22EA"
		);
	return (
		<div id={id} className={"common-slider"}>
			<Swiper
				modules={[Navigation, Pagination]}
				spaceBetween={32}
				slidesPerView="auto"
				navigation={{
					nextEl: `#${id} .custom-next`,
					prevEl: `#${id} .custom-prev`,
				}}
				pagination={{
					clickable: true,
					el: `#${id} .custom-pagination`,
				}}
				centeredSlides={false}
				loop={false}
				className="w-full"
				onSlideChange={(swiper) => {
					if (setActiveColor) {
						const slide = slides[swiper.realIndex];
						const score = slide?.cutinScore;
						const color =
							score == null || score < 4
								? "#2CC2F9"
								: score <= 7
								? "#A9F958"
								: "#FE22EA";

						setActiveColor(color);
					}
				}}
			>
				{slides.map((slide, index) => (
					<SwiperSlide key={index}>
						<ColorfulCard
							slide={slide}
							kind={
								kind
									? kind
									: slide.classType
									? getType(slide.classType)?.kind ?? ""
									: ""
							}
							activeGenre={activeGenre}
						/>
					</SwiperSlide>
				))}
			</Swiper>
			<div className="mt-6 flex justify-center">
				<div
					className="custom-controls flex items-center gap-4 px-4 py-1 rounded-lg"
					style={{ minWidth: "200px", justifyContent: "center" }}
				>
					<button className="custom-prev text-white text-2xl">
						<FiArrowRight />
					</button>

					<div className="custom-pagination flex"></div>
					<button className="custom-next text-white text-2xl">
						<FiArrowLeft />
					</button>
				</div>
			</div>
		</div>
	);
};

export default ColorfulSlider;
